"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentCallsLogForHostUser = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ui_react_1 = require("@streem/ui-react");
const analytics_1 = require("@streem/analytics");
const toolbox_1 = require("@streem/toolbox");
const call_log_1 = require("../../../context/call_log");
const RecentCallsLogForHostUser = ({ currentRoomId }) => {
    const [hostUserCallLog, setHostUserCallLog] = (0, react_1.useState)([]);
    const getCallLogHistory = (0, call_log_1.useHostRecentCallLog)();
    const elementClickedId = 'open-call-details-from-in-call-experience';
    (0, react_1.useEffect)(() => {
        if (getCallLogHistory) {
            const getCallHistory = () => __awaiter(void 0, void 0, void 0, function* () {
                const results = yield getCallLogHistory();
                setHostUserCallLog(results);
            });
            getCallHistory();
        }
    }, [getCallLogHistory]);
    const hostCallLogWithoutCurrentCall = hostUserCallLog === null || hostUserCallLog === void 0 ? void 0 : hostUserCallLog.filter(call => call.roomSid !== currentRoomId);
    const hasCalls = hostCallLogWithoutCurrentCall && hostCallLogWithoutCurrentCall.length > 0;
    const handleOpenCallDetails = (0, react_1.useCallback)((url) => {
        if (!url)
            return;
        (0, analytics_1.recordElementClicked)(elementClickedId);
        window.open(url, '_blank', 'noopener,noreferrer');
    }, []);
    return ((0, jsx_runtime_1.jsx)(ui_react_1.Box, Object.assign({ mt: "40px" }, { children: (0, jsx_runtime_1.jsxs)(ui_react_1.Box, Object.assign({ as: "section", "data-testid": "recent-calls-section" }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Subheader, Object.assign({ size: "mediumLarge", "data-testid": "recent-calls-heading" }, { children: "Recent Calls" })), hasCalls ? (hostCallLogWithoutCurrentCall.map(call => {
                    var _a, _b;
                    const [day, time] = (0, toolbox_1.formatDateColumn)((_a = call.startTime) === null || _a === void 0 ? void 0 : _a.toISOString(), {
                        returnDayAndTime: true,
                        dateFormat: { month: 'short', day: 'numeric', year: 'numeric' },
                    });
                    const duration = (0, toolbox_1.getDuration)(call.startTime, call.endTime);
                    return ((0, jsx_runtime_1.jsx)(ui_react_1.TooltipButton, { disabledTooltip: !call.callDetailsUrl, width: "290px", tooltipPlacement: "top", tooltipMessage: (0, jsx_runtime_1.jsxs)(ui_react_1.Row, Object.assign({ alignItems: "center", style: { gap: '10px' } }, { children: [(0, jsx_runtime_1.jsx)(ui_react_1.Box, Object.assign({ flexBasis: "10%" }, { children: (0, jsx_runtime_1.jsx)(ui_react_1.AppIcon, { name: "OpenLinkIcon" }) })), (0, jsx_runtime_1.jsxs)(TruncatedText, { children: ["Open ", `${call.urlHostname}${call.callDetailsUrl}`] })] })), variant: "tertiary", disabledButton: !call.callDetailsUrl, onClick: () => handleOpenCallDetails(call.callDetailsUrl), buttonText: (0, jsx_runtime_1.jsx)("time", Object.assign({ dateTime: (_b = call.startTime) === null || _b === void 0 ? void 0 : _b.toISOString() }, { children: `${day} at ${time} - ${duration}` })) }, call.roomSid));
                })) : ((0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ as: "p", color: "medium" }, { children: "You have no recent calls for this customer." })))] })) })));
};
exports.RecentCallsLogForHostUser = RecentCallsLogForHostUser;
const TruncatedText = (0, ui_react_1.styled)(ui_react_1.AppText)(() => ({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
}));
//# sourceMappingURL=recent_calls_log_host.js.map